<template>
  <footer class="footer relative">
    <div class="flex justify-between <laptop:(flex-col mt-0)">
      <IntroBlock class="footer-content-block" />
      <div class="verticle-divider"></div>
      <ServiceIntroBlock class="footer-content-block <laptop:mt-5" />
      <div class="verticle-divider"></div>
      <ContactUsBlock class="footer-content-block" />
    </div>

    <nav class="footer-legal">
      <router-link :to="{ name: 'PrivacyPolicy' }">隱私權暨個人資料保護政策</router-link>
      <span aria-hidden="true">｜</span>
      <router-link :to="{ name: 'ConsumerRights' }">消費者權益保障條款</router-link>
      <span aria-hidden="true">｜</span>
      <router-link :to="{ name: 'MemberTerms' }">會員服務條款</router-link>
    </nav>

    <div class="pt-15px">
      <p>v {{ configuration('appVersion') || 'local' }}</p>
    </div>

  </footer>
  <!-- v{{ configuration('appVersion') }} -->
</template>

<script setup>
import IntroBlock from './components/IntroBlock.vue'
import ServiceIntroBlock from './components/ServiceIntroBlock.vue'
import ContactUsBlock from './components/ContactUsBlock.vue'
import configuration from '@/configuration'
</script>

<style scoped lang="postcss">
.footer {
  @apply p-[20px] pb-[45px] mt-[60px] max-w-1150px mx-auto;
}

.verticle-divider {
  @apply bg-primary-100 w-[2px] h-[272px];
  @apply <laptop: hidden;
}

.footer-content-block {
  @apply laptop:max-w-[314px];
}

.footer-legal {
  @apply flex flex-wrap items-center justify-center gap-x-[8px] gap-y-[8px] mt-[32px] pt-[24px] border-t border-fourth-dark text-[16px] leading-[1.7];
  @apply <laptop:(justify-start mt-[24px] pt-[16px] text-[14px] leading-[1.7]);

  a {
    @apply underline;
  }
}
</style>
